import React, { useEffect, useState } from 'react'
import styles from './style.module.css'
import { BiSolidBuildingHouse } from "react-icons/bi";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { FiShoppingBag } from "react-icons/fi";
import { LuTrees } from "react-icons/lu";
import { FaSchool } from "react-icons/fa";
import BulletList from '../../components/BulletList'
import Button from '../../components/Button'
import Heading from '../../components/Heading'
import SubHeading from '../../components/SubHeading'
import { useLocation } from 'react-router-dom';


const Home_4 = () => {
    const [selectedKey, setSelectedKey] = useState(1)
    const [imageLoaded, setImageLoaded] = useState(false);
    
    const handleImageLoad = () => setImageLoaded(true);

    const location = useLocation();

    const hashToKeyMap: Record<string, number> = {
        '#multi-family': 1,
        '#commercial': 2,
        '#retail': 3,
        '#hospitality': 4,
        '#university': 5,
      };

      useEffect(() => {
        let hash = location.hash;
        if (hash.endsWith('/')) {
          hash = hash.slice(0, -1); // remove trailing slash
        }
    
        const keyFromHash = hashToKeyMap[hash];
        if (keyFromHash) {
          setSelectedKey(keyFromHash);
        }
      }, [location]);
    
      useEffect(() => {
        let hash = location.hash;
        if (hash.endsWith('/')) {
          hash = hash.slice(0, -1); // normalize
        }
    
        const el = document.getElementById(hash.replace('#', ''));
        if (el) {
          setTimeout(() => {
            const offsetTop = el.getBoundingClientRect().top + window.pageYOffset;
            const isMobile = window.innerWidth <= 768;
            const scrollOffset = isMobile ? 190 : 100;
    
            window.scrollTo({
              top: offsetTop - scrollOffset,
              behavior: 'smooth',
            });
          }, 100);
        }
      }, [selectedKey, location]);
    


    let keys = [
        {
            key: 1,
            title: "Multi-Family",
            icon: <BiSolidBuildingHouse />
        },
        {
            key: 2,
            title: "Commercial",
            icon: <HiOutlineBuildingOffice2 />
        },
        {
            key: 3,
            title: "Retail",
            icon: <FiShoppingBag />
        },
        {
            key: 4,
            title: "Hospitality",
            icon: <LuTrees />
        },
        {
            key: 5,
            title: "University",
            icon: <FaSchool />
        }
    ]

    let selectedKeyContent = [
        {
            key: 1,
            content: (
                <>
                    <div  id="multi-family" className={styles['home-4-sub-2-inner-img-1']}>Multi-Family</div>
                    <div className={styles['home-4-sub-2-inner-para']}>
                        Attract and retain eco-conscious tenants with reservation-enabled EV charging. Our solution
                        integrates seamlessly with multi-family properties, providing a premium amenity that
                        generates revenue while improving tenant satisfaction.
                    </div>
                    <div className={styles['home-4-sub-2-inner-benefits']}>
                        <div>Key Benefits</div>
                        <div className='mt-2 mb-3'>
                            <BulletList items={
                                [
                                    'Attract environmentally conscious tenants',
                                    'Increase property value and rental rates',
                                    'Generate additional revenue through EV charging',
                                    'Differentiate your property in competitive markets',
                                ]
                            } />
                        </div>


                      {/* <Button className='mb-4'>Learn More</Button> */}
                    </div>
                    {/* <button className={styles['home-4-sub-2-inner-button']}>Learn More</button> */}
                    
                </>
            )
        },
        {
            key: 2,
            content: (
                <>
                    <div id="commercial" className={styles['home-4-sub-2-inner-img-2']}>Commercial</div>
                    <div className={styles['home-4-sub-2-inner-para']}>
                        Transform your commercial parking assets into profit centers.
                        Our commercial EV charging solutions enable office buildings and business parks to offer a valuable amenity while creating a new revenue stream with minimal management overhead.
                    </div>
                    <div className={styles['home-4-sub-2-inner-benefits']}>
                        <div>Key Benefits</div>
                        <div className='mt-2 mb-3'>
                            <BulletList items={
                                [
                                    'Enhance corporate sustainability initiatives',
                                    'Provide a premium amenity for tenants and visitors',
                                    'Monetize underutilized parking spaces',
                                    'Attract high-quality tenants and extend lease terms',
                                ]
                            } />
                        </div>
                        {/* <Button className='mb-4'>Learn More</Button> */}
                    </div>
                    {/* <button className={styles['home-4-sub-2-inner-button']}>Learn More</button> */}
                </>
            )
        },
        {
            key: 3,
            content: (
                <>
                    <div id='retail' className={styles['home-4-sub-2-inner-img-3']}>Retail</div>
                    <div className={styles['home-4-sub-2-inner-para']}>
                        Increase foot traffic and customer dwell time with BreatheEV charging solutions for retail locations.
                        Our reservation system ensures shoppers can plan their visits around charging sessions, boosting sales and customer loyalty.
                    </div>
                    <div className={styles['home-4-sub-2-inner-benefits']}>
                        <div>Key Benefits</div>
                        <div className='mt-2 mb-3'>
                            <BulletList items={
                                [
                                    'Increase customer dwell time and spending',
                                    'Create new revenue stream from charging fees',
                                    'Attract valuable EV owner customers to your location',
                                    `Enhance your brand's sustainability image`,
                                ]
                            } />
                        </div>
                        {/* <Button className='mb-4'>Learn More</Button> */}
                    </div>
                    {/* <button className={styles['home-4-sub-2-inner-button']}>Learn More</button> */}
                </>
            )
        },
        {
            key: 4,
            content: (
                <>
                    <div  id="hospitality" className={styles['home-4-sub-2-inner-img-4']}>Hospitality</div>
                    <div className={styles['home-4-sub-2-inner-para']}>
                        Elevate guest experiences and align with sustainability goals by offering premium EV charging at your resort or golf course.
                        BreatheEV solutions create additional revenue while reducing range anxiety for your visitors.
                    </div>
                    <div className={styles['home-4-sub-2-inner-benefits']}>
                        <div>Key Benefits</div>
                        <div className='mt-2 mb-3'>
                            <BulletList items={
                                [
                                    'Provide a premium amenity for guests',
                                    'Generate additional revenue from charging fees',
                                    `Enhance your property's sustainability profile`,
                                    `Attract environmentally conscious visitors`,
                                ]
                            } />
                        </div>
                        {/* <Button className='mb-4'>Learn More</Button> */}
                    </div>
                    {/* <button className={styles['home-4-sub-2-inner-button']}>Learn More</button> */}
                </>
            )
        },
        {
            key: 5,
            content: (
                <>
                    <div id='university' className={styles['home-4-sub-2-inner-img-5']}>University</div>
                    <div className={styles['home-4-sub-2-inner-para']}>
                        Enhance campus sustainability with charging solutions for university campuses.
                        Support academic sustainability goals while providing a valuable service to students, faculty, and visitors that improves campus experience and creates additional revenue.
                    </div>
                    <div className={styles['home-4-sub-2-inner-benefits']}>
                        <div>Key Benefits</div>
                        <div className='mt-2 mb-3'>
                        <BulletList items={
                            [
                                'Support university sustainability commitments and carbon reduction goals',
                                'Create new revenue streams from charging services for campus community',
                                `Attract environmentally conscious students and faculty to your institution`,
                                `Enhance campus reputation as a forward-thinking, green institution`,
                            ]
                        } />
                        </div>
                        {/* <Button className='mb-4'>Learn More</Button> */}
                    </div>
                    {/* <button className={styles['home-4-sub-2-inner-button']}>Learn More</button> */}
                </>
            )
        }

    ]

  return (
      <div className={styles['home-4-main-container']}>
          <div className='container'>
  
              <span className={styles['home-4-subtitle']}>Solutions</span>
              <Heading topBottomMargin={14}> Tailored EV Charging For Every Property</Heading>
              <SubHeading>
                    BreatheEV offers specialized charging solutions across various property types, each designed to
                    maximize revenue and enhance user experience.
              </SubHeading>

              <div className={styles['home-4-sub-container']}>
                    <div className={styles['home-4-sub-1']}>
                        {
                            keys.map((item) => {
                                return (
                                    <div className={`${styles['home-4-sub-1-inner']} ${selectedKey === item.key ? styles['selected'] : ''}`}
                                        key={item.key}
                                        onClick={() => { setSelectedKey(item.key); setImageLoaded(false); }}
                                    >
                                        <div className={`${styles['home-4-sub-1-inner-icon']} ${selectedKey === item.key ? styles['icon-selected'] : styles['icon-not-selected']}`}><span>{item.icon}</span></div>
                                        <div className={`${styles['home-4-sub-1-inner-header']} ${selectedKey !== item.key ? styles['header-not-selected'] : ''}`}>{item.title}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className={styles['home-4-sub-2']}>
                        
                        {
                            selectedKeyContent.map((item) => {
                                if (item.key === selectedKey) {
                                    return (
                                        <div className={`${styles['home-4-sub-2-inner']} ${styles['fade-transition']}`} key ={item.key}>
                                            {item.content}
                                        </div>
                                    )
                                }
                            })
                        }
                    </div>
              </div>
          </div>
      </div>
  )
}

export default Home_4